import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";
import { StripAlphaCharacters } from "../utils/currency-field";
import * as Cookies from 'js-cookie';
import Vue from 'vue';


@Options({
    template: false,
    ui: {}
})

export default class DonationWidgetView extends Marionette.View<Backbone.Model>{
    config?: object;
    element?: any;
    instanceID?: number;
    fundID?: number;
    sourceCode?: number;
    text?: string;
    title?: string;
    prices?: object[];
    price?: number;
    isInputActive?: boolean;
    minimumDonation?: number;

    constructor(options?: object, config?: object) {
        super(options);
        this.config = config || {};

        this.element = this.$el.get(0);

        const urlParams = new URLSearchParams(window.location.search);
        const sourceCodeParam = urlParams.get('sourcenumber');

        this.instanceID = this.element.getAttribute('data-id');
        this.title = this.element.getAttribute('data-title') || '';
        this.text = this.element.getAttribute('data-text') || '';
        this.fundID = this.element.getAttribute('data-fund-id') || 0;
        this.sourceCode = sourceCodeParam || Cookies.get('source_number_details') || this.element.getAttribute('data-sourcecode') || 0;
        this.minimumDonation = 10;

        if(this.element.getAttribute('data-prices')) {
            this.prices = [];
            let prices = this.element.getAttribute('data-prices')
            .split('|');

            for (let index = 0; index < prices.length; index++) {

                let displayPrice = prices[index];
                let dataPrice = parseInt(prices[index].trim().replace(/\D/g, ''));

                if (dataPrice != null && !isNaN(dataPrice)) {
                    this.prices.push({
                        displayPrice: displayPrice.trim(),
                        dataPrice: dataPrice
                    });
                }
            }

        } else {
            this.prices = [];
        }

    }

    onRender() {
        let app = new Vue({
            el: this.element,
            data: {
                instanceID: this.instanceID,
                title: this.title,
                text: this.text,
                prices: this.prices,
                price: 0,
                fundID: this.fundID,
                sourceCode:  this.sourceCode,
                minimumDonation: this.minimumDonation,
                isInputActive: false
            },
            computed: {
                isDisabled() {
                    return this.selectedPrice < this.minimumDonation;
                },
                sortedPrices: function() {
                    let p = this.prices.slice();
                    p.sort();

                    return p;
                },
                selectedPrice: {
                    get() {
                        if (this.isInputActive) {
                            // Cursor is inside the input field. unformat display value for user
                            return this.price.toString()
                        } else {
                            // User is not modifying now. Format display value for user interface

                            if (this.price <= 0) {
                                return '';
                            } else {
                                return this.price.toLocaleString()
                            }
                        }
                    },
                    set(modifiedValue: string) {
                        this.price = StripAlphaCharacters(modifiedValue);
                    }
                },
                link: function() {
                    let domain = window['DJANGO']['boDomain'];

                    domain += '/donate/'
                    domain += this.fundID
                    domain += '/add-to-basket/'
                    domain += this.price

                    if(this.sourcecode !== 0) {
                        domain += '?sourceNumber=' + this.sourceCode
                    }

                    return domain
                }
            },
            methods: {
                select: function(price) {
                    this.selectedPrice = price.toString();
                },
                checkDisabled: function(e){
                    let value = this.selectedPrice.replace(/\,/g,''); // Remove commas from currency value
                    value = parseFloat(value);

                    if (value < this.minimumDonation || isNaN(value)) {
                        e.preventDefault();
                    }
                }
            }
        })
    }
}




// WEBPACK FOOTER //
// ./@modules/views/donation-widget-view.ts